export default typeof window === "undefined" ? null : window as any;
